import { Button, styled } from '@mui/material';
export const ButtonAnimation = styled(Button)(({ theme }) => ({
    margin: 'auto',
    borderRadius: '50em',
    border: '2.5px solid transparent',
    width: 'max-content',
    padding: '3px 4px',
    background: theme.palette.mode === 'dark'
        ? 'linear-gradient(darkslategray, darkslategray) padding-box,\n' +
            'conic-gradient(from var(--angle, 360deg), #66ffff, #162929,#66ffff,#162929,#66ffff) border-box'
        : 'linear-gradient(white, white) padding-box,\n' +
            'conic-gradient(from var(--angle, 360deg), #66ffff, #162929,#66ffff,#162929,#66ffff) border-box',
    animation: ' stroke 2s infinite linear',
    '@keyframes stroke': {
        '100%': {
            '--angle': '330deg',
        },
        '90%': {
            '--angle': '300deg',
        },
        '80%': {
            '--angle': '270deg',
        },
        '70%': {
            '--angle': '240deg',
        },
        '60%': {
            '--angle': '210deg',
        },
        '50%': {
            '--angle': '180deg',
        },
        '40%': {
            '--angle': '150deg',
        },
        '30%': {
            '--angle': '120deg',
        },
        '20%': {
            '--angle': '90deg',
        },
        '10%': {
            '--angle': '60deg',
        },
        '0%': {
            '--angle': '30deg',
        },
    },
    '@property --mui-angle': {
        syntax: "'<angle>'",
        initialValue: '0deg',
        inherits: false,
    },
}));
